import { Directive, HostListener, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { GridApi } from 'ag-grid-community';
import { Subject, take, takeUntil, tap } from 'rxjs';

@Directive({
  selector: 'ag-grid-angular[agGridFitWidth]',
  standalone: false,
})
export class AgGridFitWidthDirective implements OnInit, OnDestroy {
  private readonly agGrid = inject(AgGridAngular);

  @Input('agGridFitWidth') watchChanges = false;

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    if (this.watchChanges) {
      setTimeout(() => this.api.sizeColumnsToFit());
    }
  }

  api: GridApi;
  destroySubject = new Subject<void>();

  ngOnInit(): void {
    this.agGrid.gridReady.pipe(
      take(1),
      tap(params => {
        params.api.sizeColumnsToFit();
        this.api = params.api;
      }),
      takeUntil(this.destroySubject),
    ).subscribe();

    this.agGrid.rowDataUpdated.pipe(
      this.watchChanges ? tap(() => null) : take(1),
      tap(params => params.api.sizeColumnsToFit()),
      takeUntil(this.destroySubject),
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }
}
